(function () {
  const selector = '[data-sd-favorites]';

  class SDFavoriteProducts {
    constructor(element) {
      if (element.dataset.favoritesInitialized === 'true') return;

      this.element = element;
      this.viewport = element.querySelector('[data-favorites-viewport]');
      this.items = Array.from(element.querySelectorAll('[data-favorites-item]'));
      this.previousButton = element.querySelector('[data-favorites-previous]');
      this.nextButton = element.querySelector('[data-favorites-next]');
      this.status = element.querySelector('[data-favorites-status]');
      this.pageStarts = [];
      this.currentPage = 0;
      this.scrollFrame = null;

      if (!this.viewport || this.items.length === 0) {
        this.setNavigationHidden(true);
        return;
      }

      element.dataset.favoritesInitialized = 'true';
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.previousButton?.addEventListener('click', () => this.goToPage(this.currentPage - 1));
      this.nextButton?.addEventListener('click', () => this.goToPage(this.currentPage + 1));
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.viewport);
      this.rebuild();
    }

    getItemsPerPage() {
      if (window.matchMedia('(min-width: 990px)').matches) return 5;
      if (window.matchMedia('(min-width: 750px)').matches) return 3;
      return 2;
    }

    rebuild() {
      const itemsPerPage = this.getItemsPerPage();
      const lastPageStart = Math.max(0, this.items.length - itemsPerPage);
      this.pageStarts = [];

      for (let index = 0; index < this.items.length; index += itemsPerPage) {
        this.pageStarts.push(Math.min(index, lastPageStart));
      }

      this.pageStarts = [...new Set(this.pageStarts)];
      this.setNavigationHidden(this.pageStarts.length <= 1);
      this.updateCurrentPage();
    }

    setNavigationHidden(hidden) {
      [this.previousButton, this.nextButton].forEach((button) => {
        if (button) button.hidden = hidden;
      });
    }

    goToPage(pageIndex) {
      const boundedPage = Math.max(0, Math.min(pageIndex, this.pageStarts.length - 1));
      const target = this.items[this.pageStarts[boundedPage]];
      if (!target) return;

      const firstItemOffset = this.items[0].offsetLeft;
      this.viewport.scrollTo({ left: target.offsetLeft - firstItemOffset, behavior: 'smooth' });
    }

    updateCurrentPage() {
      const scrollLeft = this.viewport.scrollLeft;
      const maximumScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      let closestPage = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      if (maximumScroll > 0 && Math.abs(maximumScroll - scrollLeft) < 2) {
        closestPage = this.pageStarts.length - 1;
      } else {
        const firstItemOffset = this.items[0].offsetLeft;
        this.pageStarts.forEach((itemIndex, pageIndex) => {
          const itemPosition = this.items[itemIndex].offsetLeft - firstItemOffset;
          const distance = Math.abs(itemPosition - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestPage = pageIndex;
          }
        });
      }

      const changed = closestPage !== this.currentPage;
      this.currentPage = closestPage;
      this.updateButton(this.previousButton, this.currentPage === 0);
      this.updateButton(this.nextButton, this.currentPage === this.pageStarts.length - 1);

      if (changed && this.status) {
        this.status.textContent = `Produktseite ${this.currentPage + 1} von ${this.pageStarts.length}`;
      }
    }

    updateButton(button, disabled) {
      if (!button) return;
      button.disabled = disabled;
      button.setAttribute('aria-disabled', String(disabled));
    }

    onScroll() {
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => this.updateCurrentPage());
    }

    onResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => this.rebuild(), 100);
    }
  }

  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach((element) => new SDFavoriteProducts(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
